module.exports = __webpack_public_path__ + "media/newstyle/images/logo-clube-de-autores-share-2b85803e13069b851bd9aa734356e06c.svg";